import initSearchForm from "./elements/search-form.mjs"

initSearchForm();